import type { InvoicingPreview } from '@repo/shared-types';
import { oldestOwedMonth } from './staleOpen';

/**
 * Whether the workbench should nudge "tháng M sẵn sàng chốt sổ", how many
 * un-marked sessions still stand in the way, and the oldest earlier month
 * still owed a close.
 *
 * All three answers come from the billing engine's preview for M rather than
 * from raw sessions, because the engine is what actually decides them:
 *   - `payers` is empty once M has been chốt sổ'd (already-billed enrollments
 *     are skipped by the idempotency guard), so empty = nothing left to close.
 *   - `pendingCount` counts un-marked sessions in the month being RECONCILED
 *     (M-1) — those are what block closing M. M's own attendance is irrelevant
 *     here; it belongs to the NEXT month's close.
 *   - `oldestOwed` is the `closeLabel` of the oldest stranded period in
 *     `staleOpen`, or null when nothing is stale. The nudge previews only the
 *     current month, so without this it goes silent about an owed earlier
 *     month the instant the calendar rolls over into a new one.
 */
export function chotNudgeState(
  preview: InvoicingPreview | undefined,
): { show: boolean; pending: number; oldestOwed: string | null } {
  if (!preview || preview.payers.length === 0) return { show: false, pending: 0, oldestOwed: null };
  return { show: true, pending: preview.pendingCount, oldestOwed: oldestOwedMonth(preview.staleOpen) };
}
